var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M488.727,279.273H256H23.273C10.42,279.273,0,289.693,0,302.545v186.182 C0,501.58,10.42,512,23.273,512H256h232.727C501.58,512,512,501.58,512,488.727V302.545C512,289.693,501.58,279.273,488.727,279.273 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed7714"
    },
    d: "M272.466,6.82c-0.545-0.543-1.116-1.058-1.711-1.547c-0.267-0.219-0.552-0.413-0.828-0.621 c-0.332-0.248-0.658-0.506-0.999-0.734c-0.332-0.222-0.683-0.419-1.027-0.624c-0.307-0.183-0.61-0.377-0.923-0.546 c-0.352-0.188-0.717-0.349-1.077-0.518c-0.329-0.155-0.653-0.32-0.987-0.458c-0.349-0.144-0.711-0.262-1.067-0.391 c-0.36-0.129-0.718-0.268-1.081-0.379c-0.357-0.109-0.723-0.188-1.085-0.279c-0.375-0.093-0.746-0.199-1.125-0.275 c-0.417-0.082-0.844-0.133-1.268-0.194c-0.329-0.047-0.655-0.11-0.984-0.143C257.548,0.042,256.782,0,256.006,0 s-1.542,0.042-2.298,0.116c-0.329,0.033-0.656,0.095-0.984,0.141c-0.424,0.061-0.852,0.112-1.269,0.194 c-0.375,0.074-0.748,0.18-1.122,0.275c-0.363,0.092-0.731,0.171-1.086,0.279c-0.361,0.11-0.718,0.248-1.077,0.377 c-0.358,0.127-0.723,0.247-1.074,0.393c-0.329,0.137-0.647,0.299-0.971,0.451c-0.366,0.172-0.737,0.337-1.092,0.526 c-0.304,0.163-0.596,0.352-0.894,0.528c-0.355,0.211-0.717,0.414-1.06,0.644c-0.318,0.214-0.624,0.455-0.934,0.686 c-0.299,0.222-0.608,0.433-0.895,0.669c-0.507,0.419-0.999,0.869-1.479,1.336c-0.071,0.07-0.15,0.129-0.222,0.2l-77.579,77.573 c-9.087,9.087-9.089,23.824-0.002,32.912c9.089,9.089,23.825,9.089,32.914,0.002l37.851-37.846v129.998 c0,12.853,10.42,23.273,23.273,23.273c12.853,0,23.273-10.42,23.273-23.273V79.458l37.845,37.845 c4.544,4.544,10.501,6.817,16.457,6.817s11.913-2.273,16.455-6.817c9.089-9.089,9.089-23.824,0-32.912L272.466,6.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77757F"
    },
    d: "M302.55,372.357c-6.128,0-12.133,2.482-16.462,6.827c-4.329,4.329-6.811,10.318-6.811,16.446 s2.482,12.133,6.811,16.462c4.329,4.329,10.333,6.811,16.462,6.811c6.111,0,12.117-2.482,16.446-6.811 c4.344-4.329,6.827-10.333,6.827-16.462c0-6.113-2.484-12.117-6.827-16.446C314.667,374.84,308.662,372.357,302.55,372.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77757F"
    },
    d: "M395.641,372.357c-6.128,0-12.133,2.482-16.462,6.827c-4.329,4.329-6.811,10.333-6.811,16.446 c0,6.129,2.482,12.133,6.811,16.462c4.329,4.329,10.333,6.811,16.462,6.811c6.127,0,12.117-2.482,16.446-6.811 c4.329-4.329,6.827-10.333,6.827-16.462c0-6.113-2.498-12.117-6.827-16.446C407.758,374.84,401.768,372.357,395.641,372.357z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77757F"
    },
    d: "M23.273,279.273C10.42,279.273,0,289.693,0,302.545v186.182C0,501.58,10.42,512,23.273,512H256 V279.273H23.273z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubUpload);
export default __webpack_public_path__ + "static/media/sub-upload.1abef651eca20e3fb4ddea041e900d5e.svg";
export { ForwardRef as ReactComponent };